var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"color"},_vm._l((_vm.formBins),function(bin,index){return (bin > 0)?_c('span',{key:index,style:({
			width: _vm.binWidth(bin, _vm.colorTotal),
			background: _vm.getBackground(index)
		})},[_c('div',{staticClass:"image"},[_c('img',{attrs:{"src":_vm.formImage(index + 1)}})]),_c('label',[_vm._v("\n\t\t\t"+_vm._s(_vm.binLabel(bin, _vm.colorTotal))+"\n\t\t")])]):_vm._e()}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }